    <div>
      ({{ startRange() }} -
      {{
        endRange() > totalItems
          ? totalItems
          : endRange()
      }}
      of {{ totalItems }})
    </div>
